import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import { EDTextField, EDTypography, error, info } from "@trailblazer-game/ed-webkit";
import Stack from "@mui/material/Stack";
import DebugTools from "../../../DebugTools/DebugTools";
import { ELeagueActions, ELeaguePhase, fakeRanks, ILeagueState } from "../Public/League_State";
import { SessionContext, SessionContextInterface } from "../../../../hooks/SessionHook/SessionContext";
import { EEventActions } from "../../Event/Public/Event_State";
import { log, warn } from "../../../../helpers/utils/log";
import { ClientLeagueAPI } from "@trailblazer-game/leaderboards-sdk";

const clientLeagueAPI = new ClientLeagueAPI();

export interface ILeagueDebugToolsProps {
  className?: string;
  state: ILeagueState;
  dispatch: Function;
}

function League_DebugTools({ className, state, dispatch }: ILeagueDebugToolsProps) {
  const { tbUid } = React.useContext(SessionContext) as SessionContextInterface;
  const [ customPosition, setCustomPosition ] = useState(88);
  const setPhase = (phase: ELeaguePhase) => {
    dispatch({ type: ELeagueActions.SetPhase, phase })
  }

  const addFakeRanks = () => {
    dispatch({ type: ELeagueActions.LoadRankingsSuccess, ranks: fakeRanks(tbUid, customPosition) })
  }

  const reloadConfig = () => {
    const loadLeaderboardConfig = async () => {
      dispatch({ type: ELeagueActions.LoadConfig });

      let res = await clientLeagueAPI.getConfig();

      if (res.success) {
        const config = res.config;
        log('Event', `Loaded leaderboard config: `, res.config);
        dispatch({ type: ELeagueActions.LoadConfigSuccess, config });
        return;
      }

      dispatch({
        type: ELeagueActions.LoadConfigFail,
        logMessage: { message: "Cannot load config", color: error("main") }
      });

      warn('Event', "Something went wrong while getting configuration:", res);
    }

    loadLeaderboardConfig();
  }

  return <DebugTools className={className}>
    <Stack direction={"column"} spacing={1}>
      <EDTypography className={"action"} variant={"body2"} onClick={() => setPhase(ELeaguePhase.StartingSoon)}>Switch
        to <b>starting soon</b></EDTypography>
      <EDTypography className={"action"} variant={"body2"} onClick={() => setPhase(ELeaguePhase.OnGoing)}>Switch to <b>on
        going</b></EDTypography>
      <EDTypography className={"action"} variant={"body2"} onClick={() => setPhase(ELeaguePhase.Ended)}>Switch
        to <b>ended</b></EDTypography>
      <EDTypography className={"action"} variant={"body2"} onClick={() => reloadConfig()}>Reload config</EDTypography>

      <Stack className={"input"} spacing={2}>
        <EDTypography className={"action"} variant={"body2"} onClick={() => addFakeRanks()}>Add fake ranks</EDTypography>
        <EDTextField label={"Custom position"} onSubmit={(v) => {
          setCustomPosition(+(v || 0))
          dispatch({ type: EEventActions.LoadRankingsSuccess, ranks: fakeRanks(tbUid, +(v || 0) || 0) })
        }} onChange={(v) => setCustomPosition(+(v || 0))}/>
      </Stack>
    </Stack>
  </DebugTools>
}

const LeagueDebugToolsStyled = styled(League_DebugTools)(() => ({
  ".action": {
    color: info("main"),
    cursor: "pointer"
  }
}));

// Export
export default LeagueDebugToolsStyled;